<template>
<div class="organization-update update-form">
  <form class="organization-update--form" @submit.prevent="update">
    <h3>{{$t('ui.organizations.general_settings')}}</h3>
    <!-- Base setting -->
    <div class="grid-2 has-gutter-l organization--base">
      <div>
        <field :errors="errors" name="name" class="two-thirds" label="Name" v-model="item.name" placeholder="Google inc."></field>
        <field :errors="errors" class="is-inline" model="organizations" name="locale" label="Language" type="radio" :params="{'no_i18n': true}" :collection="[{value:'en', name:'en'},{value:'de', name:'de'}]" v-model="item.locale"></field>
        <field :errors="errors" name="website" label="Website" v-model="item.website" placeholder="http://zombo.com/"></field>
        <field :errors="errors" v-if="currentUserIsRoot" label="Plan" :params="{no_i18n: true}" :required="true" v-model="item.plan" :collection="this.plans" name="plan" type="select"></field>
      </div>
      <div>
        <div class="company-logo">
          <img v-if="company_logo_data" :src="company_logo_data" alt="logo">
          <img v-else-if="item.company_logo_url" :src="item.company_logo_url" alt="logo">
          <upload-field @change="logoUpload"/>
        </div>
        <field :errors="errors" name="status" class="is-inline" type="radio" :params="{'no_i18n': true}" label="Active organization ?" :collection="[{value:'active', name:'Yes'},{value:'inactive', name:'No'}]" v-model="item.status"></field>
      </div>
    </div>
    <!-- Address setting -->
    <div class="grid-2 has-gutter-l organization--address">
      <div>
        <field :errors="errors" name="street" label="Street" v-model="item.street" placeholder="Hausburgstr"></field>
        <field :errors="errors" name="city" label="City" v-model="item.city" placeholder="Berlin"></field>
      </div>
      <div>
        <div class="grid-2 has-gutter-l">
          <field :errors="errors" name="street_number" label="Street number" v-model="item.street_number" placeholder="30"></field>
          <field :errors="errors" name="zip" label="Zip code" v-model="item.zip" placeholder="10249"></field>
        </div>
        <country-select :errors="errors" name="country" label="Country" v-model="item.country"></country-select>
      </div>
    </div>

    <div v-if="type == 'update'">

      <h3>{{$t('ui.organizations.configuration')}}</h3>
      <!-- Frontend/UI settings -->
      <div class="grid-2 organization--configuration">
        <div>
          <form-switch v-if="configuration.ranking_display" model="organization_configuration" name="ranking_display" v-model="configuration.ranking_display.content"></form-switch>
        </div>
        <div>
          <form-switch v-if="configuration.enrichment_disabled" :reverse="true" model="organization_configuration" name="enrichment_disabled" v-model="configuration.enrichment_disabled.content"></form-switch>
        </div>
      </div>

      <h3>{{$t('ui.organizations.api')}}</h3>
      <div class="grid-2 has-gutter-l">
        <div>
          <secret-field v-if="configuration.eventbaxx_auth_token" :errors="errors" model="organization_configuration" name="eventbaxx_auth_token" v-model="configuration.eventbaxx_auth_token.content" set_state='api'></secret-field>
          <secret-field v-if="configuration.api_token_eventbaxx" :errors="errors" model="organization_configuration" name="api_token_eventbaxx" v-model="configuration.api_token_eventbaxx.content"></secret-field>
        </div>
        <div>
          <secret-field v-if="configuration.mailchimp_api_key" :errors="errors" model="organization_configuration" name="mailchimp_api_key" v-model="configuration.mailchimp_api_key.content"></secret-field>
            <secret-field v-if="configuration.xing_consumer_key" :errors="errors" model="organization_configuration" name="xing_consumer_key" v-model="configuration.xing_consumer_key.content"></secret-field>
        </div>
      </div>

    </div>

    <div class="organization-update-form--actions">
      <button class="btn btn-tertiary" @click="cancel" data-action="organization.cancel">{{ $t('ui.global.cancel') }}</button>
      <button class="btn btn-primary btn-save" type="submit" data-action="organization.update">{{ $t('ui.global.save') }}</button>
    </div>
  </form>
</div>
</template>
<script>
import Api from '@/api/Organization.js'
import Plan from '@/api/Plan.js'
import CountrySelect from '@/components/helpers/DataInput/CountrySelect'
import {updateMixin} from '@/components/mixins/Update'
import FormSwitch from '@/components/helpers/DataInput/FormSwitch'
import SecretField from '@/components/helpers/DataInput/SecretField'
import Configuration from '@/classes/Configuration'
import UploadField from '@/components/helpers/DataInput/UploadField'

let configuration_list = [
  {name: 'ranking_display', type: 'ui'},
  {name: 'eventbaxx_auth_token', type: 'api'},
  {name: 'api_token_eventbaxx', type: 'secret'},
  {name: 'enrichment_disabled', type: 'api'},
  {name: 'mailchimp_api_key', type: 'secret'},
  {name: 'xing_consumer_key', type: 'secret'},
]

export default {
  mixins: [updateMixin],
  components: { CountrySelect, FormSwitch, SecretField, UploadField },
  data(){
    return {
      model: "organizations",
      api: new Api(),
      configuration: {},
      plans: [],
      company_logo_data: null
    }
  },
  computed: {
    currentUserIsRoot() {
      return this.$store.getters.currentUser.role === 'root'
    }
  },
  async mounted(){
    this.fetchPlans()
    if(this.type == 'update'){
      let configuration = await this.retrieveConfiguration()
      this.configuration = Configuration.mapConfiguration(configuration)
      configuration_list.forEach(configuration=>{
        if(_.isEmpty(this.configuration[configuration['name']])){
          this.configuration[configuration['name']] = {
            configuration_type: configuration['type']
          }
        }
      })
    }
  },
  methods: {
    async retrieveConfiguration(){
      let organization_id = this.id
      return await this.api.configuration(organization_id)
    },
    async fetchPlans() {
      let planApi  = new Plan()
      let { resources } = await planApi.all({disable_pagination: 'true'})
      // Only grab name attribute
      this.plans   = resources.reduce((prev, curr, idx) => {
        prev.push({name: curr.name, value: curr.name})
        return prev
      }, [])
    },
    update() {
      // update organization
      this.api.post(this.item).then((item) => {
        this.item = item
        // update organization configuration
        if(this.type == 'update'){
          this.api.update_configuration(this.id, this.configuration).then((config) => {
            this.configuration = config

            this.$store.commit('SET_NOTIFICATION', {
              'title': 'models.' + this.singular_model + '.message.' + this.type,
              'type': 'success'
            })
            Configuration.setOrganizationConfig(this.$store.getters.currentUser)
            this.$router.push(this.redirection)
          }).catch((e) => {
            this.errors = e.response.data.errors
            this.$store.commit('SET_NOTIFICATION', {
              'title': 'errors.' + e.response.data.errors[0].code,
              'type': 'error'
            })
          })
        }else{
          this.$router.push(this.redirection)
        }
      }).catch((e) => {
        this.errors = e.response.data.errors
      })

    },
    logoUpload(payload){
      let file = payload
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.company_logo_data = reader.result
        this.item.company_logo_url = null
        this.item.company_logo_data = reader.result
      };
    },
    mapConfiguration(configuration){
      let output = {}
      configuration.forEach((value,key)=>{
        output[value['key']] = {
          content: value['content'],
          configuration_type: value['configuration_type']
        }
      })
      return output
    }
  }
}

</script>
<style lang="scss" scoped>
h3{
  margin-bottom: 10px;
}
.organization-update-form--actions{
  text-align: right;
  margin-top: 25px;
  .btn-tertiary {
    margin-right: 1em;
  }
}

</style>



// WEBPACK FOOTER //
// OrganizationUpdate.vue?9005ec4c